import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mail",
  "use": "icon-mail-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-mail\"><path d=\"M24.571 6A3.43 3.43 0 0 1 28 9.429v13.714a3.43 3.43 0 0 1-3.429 3.428H7.43A3.43 3.43 0 0 1 4 23.143V9.429A3.43 3.43 0 0 1 7.429 6ZM6.006 12.198l.001 10.945c0 .946.475 1.428 1.422 1.428H24.57c.947 0 1.44-.482 1.44-1.428V12.282l-8.435 7.257c-.646.645-1.595.683-2.276.114l-.124-.114zM24.571 7.99H7.43c-.947 0-1.422.492-1.422 1.439l-.001.086L16.343 18l9.668-8.544v-.027c0-.891-.437-1.38-1.277-1.434z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol